module.exports = __webpack_public_path__ + "static/media/icon-live-stats.2be608d6.svg";